import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    '& .wp-block-embed.is-type-video': {
        marginLeft: 0,
        marginRight: 0,

        '& .wp-block-embed__wrapper': {
            position: 'relative',
            paddingTop: '56.25%'
        },

        iframe: {
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%'
        }
    }
})

export default style
